import { styled, css, Box } from '@mui/material'
import Text from '../Text'
import Price from '../Price'

export const SummaryListWrapper = styled(Box)(
  ({ theme }) => css`
    background-color: ${theme.palette.background.default};
  `
)

export const SummaryListHeader = styled(Box)(
  () => css`
    display: flex;
    flex-direction: column;
    align-items: start;
    gap: 12px;
    justify-content: space-between;
  `
)

export const SummarySideContainer = styled(Text)(
  ({ theme }) => css`
    font-size: 10px;
    font-weight: 400;
    color: ${theme.palette.text.secondary};
  `
)

export const SummaryHeading = styled(Text)(
  ({ theme }) => css`
    color: ${theme.palette.text.primary};
    font-size: 12px;
    font-weight: 700;
    &:first-letter {
      text-transform: capitalize;
    }
  `
)

export const SummaryWrapper = styled(Box)(
  () => css`
    display: flex;
    flex-direction: row;
    gap: 10px;
    align-items: center;
  `
)

export const SummaryTotalWrapper = styled(Box)(() => css``)

export const SummaryItemWrapper = styled(Box)(() => css``)

export const SummaryHeadingCount = styled(Text)(
  ({ theme }) => css`
    font-size: 10px;
    font-weight: 400;
    color: ${theme.palette.text.secondary};
  `
)

export const ProductQuantityWrapper = styled(Text)(
  () => css`
    display: flex;
    max-width: 20%;
    flex: 1;
    align-items: center;
    justify-content: center;
  `
)

export const ProductName = styled(Box)(
  () => css`
    font-weight: 700;
    font-size: 12px;
  `
)

export const ProductDetails = styled(Box)(
  () => css`
    display: flex;
    flex-direction: column;
    flex: 1;
    align-items: start;
  `
)

export const PriceDetail = styled(Box)(
  () => css`
    font-size: 12px;
    font-weight: 500;
    flex: 1;
    justify-content: end;
  `
)

export const PricePerUnit = styled(Price)(
  ({ theme }) => css`
    font-size: 9px;
    width: fit-content;
    padding: 2px;
    border: 1px solid ${theme.palette.success.main};
    border-radius: 2px;
  `
)
PricePerUnit.defaultProps = {
  color: 'success.main'
}
